"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 2H10L4 8v14h16zm-7 15h-2v-2h2zm0-4h-2V8h2z"
}), 'SimCardAlertSharp');